import type { DataViewMode } from 'components/DataView';

import { OrdersDataTableView } from '../OrdersDataTableView';
import { OrdersTrelloView } from '../OrdersTrelloView';
import type { OrderRow } from './orderBuckets';

/**
 * Les vues prennent la pagination en paramètre : le kanban la rend visible par un bouton, là où le
 * tableau la consomme par défilement. Une fabrique plutôt qu'une constante, donc — c'est le prix à
 * payer pour que la page reste le seul endroit qui connaisse la query.
 */
export function buildOrderViews({
    hasMore,
    isLoadingMore,
    onLoadMore,
}: {
    hasMore: boolean;
    isLoadingMore: boolean;
    onLoadMore: () => Promise<unknown>;
}): DataViewMode<OrderRow>[] {
    return [
        {
            key: 'kanban',
            label: 'Kanban',
            render: ({ rows, selection }) => (
                <OrdersTrelloView
                    orders={rows}
                    selectedOrderIds={selection.selectedKeys}
                    setSelectedOrderIds={selection.setSelectedKeys}
                    toggleOrderSelection={selection.toggleKey}
                    hasMore={hasMore}
                    isLoadingMore={isLoadingMore}
                    onLoadMore={onLoadMore}
                />
            ),
        },
        {
            key: 'table',
            label: 'Tableau',
            render: ({ rows, selection }) => (
                <OrdersDataTableView
                    orders={rows}
                    selectedOrderIds={selection.selectedKeys}
                    setSelectedOrderIds={selection.setSelectedKeys}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore}
                />
            ),
        },
    ];
}
